module.exports = __webpack_public_path__ + "img/benefit4.7dc1739f.png";